module.exports = __webpack_public_path__ + "static/img/205_TO8_2120_og.4dc260e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/205_TO8_2120_og.jpg
// module id = acn4
// module chunks = 0